import "./browser/windowRequireSetup";
import browserSetup from "./browser/browserSetup";
import createBrowserTabChecker from "./browser/browserTabChecker";
import environment, { electronOnly } from "src/utils/environment";
import "./initializeCrashReporter";
import { setupI18n } from "./i18n";
import ReactDOM from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { HashRouter } from "react-router-dom";

import GlobalThemeProvider from "src/styling/GlobalThemeProvider";
import "./initializeParse";
import "./setupGlobalShortcuts";
import "./modules/firebase";
import { store, persistor } from "./store/store";
import { themeSourceChanged } from "./duck/actions";
import App from "./components/App";
import Routes from "./routing/Routes";

import setupDebugHelpers from "./debug-helpers";
import renderStory from "./stories/story";

import { Buffer } from "buffer";
window.Buffer = Buffer;

const { nativeTheme } = window.require("@electron/remote");

if (environment.debugMode) setupDebugHelpers(persistor);

electronOnly(() => {
  setupI18n();
  window.toggleDarkMode = function () {
    nativeTheme.themeSource = nativeTheme.shouldUseDarkColors
      ? "light"
      : "dark";
    store.dispatch(themeSourceChanged(nativeTheme.themeSource));
  };
});

async function main() {
  if (environment.isBrowser) {
    const { appName } = environment;
    document.title = appName.charAt(0).toUpperCase() + appName.slice(1);
    createBrowserTabChecker().check();
    await browserSetup();
  }

  if (environment.storyMode) {
    renderStory({ store, persistor });
  } else {
    ReactDOM.createRoot(document.getElementById("root")).render(
      <ReduxProvider store={store}>
        <PersistGate
          loading={<div>Retrieving persisted data.</div>}
          persistor={persistor}
        >
          <GlobalThemeProvider>
            <HashRouter>
              <App persistor={persistor}>
                <Routes />
              </App>
            </HashRouter>
          </GlobalThemeProvider>
        </PersistGate>
      </ReduxProvider>
    );
  }
}
main();
